import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'components/UI';
import { jsx as ___EmotionJSX } from "@emotion/react";

var DeleteConfirmationModal = function DeleteConfirmationModal(_ref) {
  var modalRef = _ref.modalRef,
      onDelete = _ref.onDelete,
      onClose = _ref.onClose;
  return ___EmotionJSX(Modal, {
    ref: modalRef,
    onClose: onClose
  }, ___EmotionJSX("h4", {
    className: "mb1"
  }, "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438 \u0438\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435!"), ___EmotionJSX("p", {
    className: "mb1"
  }, "\u041D\u0430\u0442\u0438\u0441\u043D\u0438 '\u0418\u0437\u0442\u0440\u0438\u0439' \u0431\u0443\u0442\u043E\u043D\u0430 \u0437\u0430 \u0434\u0430 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0435\u0448 \u0437\u0430\u043F\u0438\u0441\u0430?"), ___EmotionJSX("div", {
    css: function css(t) {
      return t.displayFlex({
        justify: 'flex-end'
      });
    }
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return modalRef.current.close();
    },
    margin: "0 1em 0 0"
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), ___EmotionJSX(Button, {
    onClick: function onClick() {
      onDelete();
      modalRef.current.close();
    }
  }, "\u0418\u0437\u0442\u0440\u0438\u0439")));
};

DeleteConfirmationModal.propTypes = {
  modalRef: PropTypes.object,
  onDelete: PropTypes.func,
  onClose: PropTypes.func
};
export default DeleteConfirmationModal;